import React from "react";
import useJumboLayout from "@jumbo/hooks/useJumboLayout";
import JumboLayoutProvider from "@jumbo/components/JumboLayout/JumboLayoutProvider";
import PropTypes from "prop-types";
import layoutConfig from "./layoutConfig";

const SoloPage = ({ children }) => {
  const { setJumboLayoutOptions } = useJumboLayout();

  React.useEffect(() => {
    setJumboLayoutOptions(layoutConfig);
  }, []);

  return (
    <JumboLayoutProvider>
      {children}
    </JumboLayoutProvider>
  );
};

SoloPage.propTypes = {
  children: PropTypes.node.isRequired
};

export default SoloPage;
